import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ViewEncapsulation, Inject, Injector } from '@angular/core';
import { Widget, DataProvider, LogService, WidegtHelperService, PieResponseObject } from 'core-dashboard';
import * as d3 from 'd3';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'pie-chart',
    template: `<div class='d3-chart' #chart></div>`,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./pie.chart.css']
})

export class PieChart extends Widget implements OnInit, OnDestroy {
    private dataProvider: any;
    private donutDataForDisplay = [];
    private donutDataForDisplayText = [];
    private pieChartData: any;
    private legendWidthOffset = 0;

    //layout
    private width: number;
    //private widthforTextSize: number;
    private height: number;
    private lastHeight: number;
    private lastWidth: number;
    private mainChart: any;
    private chart: any;
    private plotArea: any;
    private colors: any[] = [];
    //style related
    private widgetStyle: any;


    private defaultStyle: any =
        {
            "background-color": "#F2F2F2",

            "tooltip-background": "White",
            "tooltip-font-color": "Black",
            "tooltip-font": "Sans-serif",
            "tooltip-font-size": 10,

            "legend-font-color": "#37474F",
            "legend-font": "Sans-serif",
            "legend-font-size": 10,
            "legend-visible": true,
            "legend-position": "right",

            "title-visible": true,
            "title-font-color": "#efefef",
            "title-font": "Sans-serif",
            "title-font-size": 14,
            "title-background-color": "#404040",

            "font-size": 14,
            "font": "Sans-serif",
            "font-color": "#37474F",

            "colors": ["#D32F2F", "#303F9F", "#4CAF50", "#F57C00", "#C2185B", "#1976D2", "#CDDC39", "#7B1FA2", "#FFC107", "#00796B"],

            "error-font-color": "Red",
            "error-font": "Sans-serif",
            "error-font-size": 12,

            "margin": {
                "left": 5,
                "top": 5,
                "right": 5,
                "bottom": 5
            }
        };

    //vars for error notification
    private invalidData = false;
    private ERROR_TEXT = "Cannot fetch data for chart.";
    private ERROR_TEXT_INVALID_DATA_PIE = "Cannot render chart - value for all events is either zero (0) or negative";
    private pie = d3.pie().sort(null);
    //private negativeValueIndex = [];
    private chartUniqueId: any;
    private svg: any;

    @ViewChild('chart',{static:true}) private chartContainer: ElementRef;
    constructor(@Inject('dataProvider') dataProvider: any,
        @Inject("widgetStyle") widgetStyle: any,
        private injector: Injector/*private parameters: ParameterService,private http:Http*/,
        logger: LogService,
        private widgetHelper: WidegtHelperService,
        translateService: TranslateService) {
        super(logger, translateService);
        this.dataProvider = dataProvider;
        this.widgetStyle = widgetStyle;
        this.applyStyles();
    }

    ngOnDestroy() {
    }

    ngAfterViewInit() { }

    ngOnInit() {

        this.Start();
    }

    private Start() {
        try {
            if (this.dataProvider && (this.dataProvider.name !== "")) {
                let provider = this.injector.get(this.dataProvider.name) as DataProvider;
                if (provider) {
                    provider.getData(this);
                }
                else {
                    this.logger.logWarning("PieChart", "Unable to instantiate dataprovider for chart. DataProvider name: " + this.dataProvider.name)
                    this.Draw(null);
                }
            }
        }
        catch (error) {
            this.logger.logError("PieChart", "Error on ngOnInit. Error:" + error);
        }
    }


    Draw(data: PieResponseObject) {
        try {
            this.logger.logInfo("PieChart", "Received callback from provider .Drawing widget");
            // if data is incoorect display error 
            // else draw chart
            if (data === null || typeof data === 'undefined' || typeof data.ResponseArrayCollection === 'undefined') {
                let element = this.chartContainer.nativeElement;
                this.setBasicLayout(element);
                this.chartContainer.nativeElement.innerHTML = "";
                this.displayError(element, this.ERROR_TEXT, false);
                this.pieChartData = undefined;
                this.donutDataForDisplay = [];
            }
            else {
                this.pieChartData = data.ResponseArrayCollection[0];
                this.createvalueCollection(); // create values collection
                this.createChart();
            }
        }
        catch (error) {
            this.logger.logError("PieChart", "Error while drawing Pie chart. Error:" + error);
        }
    }

    private createvalueCollection() {
        //clear both collection before use
        this.donutDataForDisplay = [];
        this.donutDataForDisplayText = [];
        //this.negativeValueIndex = []
        let negativeValues = false;
        for (var i = 0; i < this.pieChartData.length; i++) {
            //maintain the list of indexes which had -ve values
            //if (this.pieChartData[i].value < 0)
            //this.negativeValueIndex.push(i);

            var value = 0;
            //consider -ve value to 0 as pie wont be considering -ve values
            if (this.pieChartData[i].value < 0)
                this.logger.logWarning("PieChart", this.pieChartData[i].key + ": " + this.pieChartData[i].value + " is treated as 0 while drawing chart");
            else
                value = this.pieChartData[i].value;
            this.donutDataForDisplay.push(value)

            //add key for the value
            this.donutDataForDisplayText.push(this.pieChartData[i].key)
        }
        //chart can not be drawn if all values are zeor.
        //therefore mark invalidData flag to true to display error instead of chart
        this.invalidData = this.donutDataForDisplay.every(x => x == 0);
    }

    setBasicLayout(element: any) {
        //  this.colors = d3.scaleLinear().domain([0, this.donutDataForDisplayText.length]).range(
        // <any[]>[this.currentStyle.start_color, this.currentStyle.end_color]);

        this.colors = this.currentStyle.colors;

        this.currentStyle.margin = typeof this.widgetStyle['margin'] !== 'undefined' ?
            this.widgetStyle['margin'] : this.defaultStyle['margin'];


        this.validateMargins();
        this.width = element.offsetWidth - (this.currentStyle.margin.right + this.currentStyle.margin.left);
        this.height = element.offsetHeight - (this.currentStyle.margin.bottom + this.currentStyle.margin.top);
        this.lastHeight = element.offsetHeight;
        this.lastWidth = element.offsetWidth;
    }

    validateMargins() {
        if (this.currentStyle.margin == undefined || this.currentStyle.margin == null) {
            this.logger.logWarning("PieChart", "resetting margins");
            this.currentStyle.margin = {
                "left": 5,
                "top": 5,
                "right": 5,
                "bottom": 5
            }
        }
    }

    createChart() {
        try {
            let element = this.chartContainer.nativeElement;

            if (element.offsetHeight != 0 && element.offsetWidth != 0)
                if (this.lastHeight != element.offsetHeight || this.lastWidth != element.offsetWidth) {

                    this.setBasicLayout(element);
                    this.invalidData = this.donutDataForDisplay.every(x => x == 0);
                    if (this.invalidData && this.pieChartData != undefined) {
                        this.chartContainer.nativeElement.innerHTML = "";
                        this.displayError(element, this.ERROR_TEXT_INVALID_DATA_PIE, this.currentStyle.legend_visible);
                        return
                    } else if (!this.pieChartData) {
                        this.chartContainer.nativeElement.innerHTML = "";
                        this.displayError(element, this.ERROR_TEXT, false);
                        return
                    }
                    this.chartContainer.nativeElement.innerHTML = "";
                    this.drawPieChart(element);
                }
        }
        catch (error) {
            this.logger.logError("PieChart", "Error while drawing Pie chart. Error:" + error);
        }
    }

    displayError(element: any, chartError: any, displayLegend: boolean) {
        try {
            this.logger.logWarning("PieChart", chartError);

            this.chartContainer.nativeElement.innerHTML = "";

            //this.readErrorProperties();
            this.svg = d3.select(element).append('svg')
                .attr('width', element.offsetWidth)
                .attr('height', element.offsetHeight)
                .style('background-color', this.currentStyle.background_color);

            this.width = element.offsetWidth - (this.currentStyle.margin.left + this.currentStyle.margin.right);
            this.height = element.offsetHeight - (this.currentStyle.margin.top + this.currentStyle.margin.bottom);
            this.mainChart = this.svg.append('g')
                .attr('width', this.width)
                .attr('height', this.height)
                .attr('transform', 'translate(' + this.currentStyle.margin.left + ',' + this.currentStyle.margin.top + ')');

            if (displayLegend) {
                this.DrawLegends(this.titleHeight + 25, true);
            }
            var erroBox = this.mainChart.append('g').attr('width', this.width)
                .attr('height', this.height);


            var redefinedError = this.NAME + " : " + chartError;

            var dummyTitle = erroBox.append("text")
                .attr('class', 'dummytitle')
                .attr("font-family", this.currentStyle.error_font)
                .style('font-size', this.currentStyle.error_font_size)
                .attr('font-size', this.currentStyle.error_font_size)
                .text(redefinedError);

            var dummytitle = erroBox.selectAll('.dummytitle');

            var titleHeight = dummytitle.node().getBBox().height;
            var translate = displayLegend ? this.currentStyle.legend_position == "left" ? ("translate(" + (this.legendWidthOffset + 5) + "," + (titleHeight - 5) + ")") : this.currentStyle.legend_position == "top" ? ("translate(" + 0 + "," + (this.legendHeightoffset + 20) + ")") : ("translate(" + 0 + "," + (titleHeight - 5) + ")") : ("translate(" + (this.width / 2) + "," + (this.height / 2) + ")")
            erroBox.selectAll('.dummytitle').remove()
            erroBox.append("text")
                .attr('transform', translate)
                .attr('class', 'errortext')

                .attr("font-family", this.currentStyle.error_font)
                .style('font-size', this.currentStyle.error_font_size)
                .attr('font-size', this.currentStyle.error_font_size)
                .style('fill', this.currentStyle.error_font_color)
                .text(redefinedError)
                .call(this.widgetHelper.textWrap);

            if (displayLegend) {
                this.mainChart.selectAll('text').attr('text-anchor', 'left')
            } else {
                this.mainChart.selectAll('text').attr('text-anchor', 'middle')
            }
        }
        catch (error) {
            this.logger.logError("PieChart", error);
        }
    }

    /*private readErrorProperties() {
        //error font color
        if (typeof this.widgetStyle['error-font-color'] !== 'undefined')
            this.currentStyle.error_font_color = this.widgetStyle['error-font-color'];
        else
            this.currentStyle.error_font_color = this.defaultStyle['error-font-color'];

        //error font size
        if (typeof this.widgetStyle['error-font-size'] !== 'undefined')
            this.currentStyle.error_font_size = this.widgetStyle['error-font-size'];
        else
            this.currentStyle.error_font_size = this.defaultStyle['error-font-size'];

        //error font
        if (typeof this.widgetStyle['error-font'] !== 'undefined')
            this.currentStyle.error_font = this.widgetStyle['error-font'];
        else
            this.currentStyle.error_font = this.defaultStyle['error-font'];
    }*/







    private titleHeight = 0;
    drawPieChart(element: any) {
        this.svg = d3.select(element).append('svg')
            .style('background-color', this.currentStyle.background_color)
            .attr('width', element.offsetWidth)
            .attr('height', element.offsetHeight)

        this.width = element.offsetWidth - (this.currentStyle.margin.left + this.currentStyle.margin.right);
        this.height = element.offsetHeight - (this.currentStyle.margin.top + this.currentStyle.margin.bottom);


        this.mainChart = this.svg.append('g')
            .attr('class', 'mainChart')
            .attr('width', this.width)
            .attr('height', this.height)
            .attr('transform', 'translate(' + this.currentStyle.margin.left + ',' + this.currentStyle.margin.top + ')');

        if (this.currentStyle.legend_visible)
            this.DrawLegends(this.titleHeight, false);

        var translates = this.getTranslateYForPie();
        this.drawArc(translates);

    }

    convertToLocaleNumber(numString: string): string {
        let num = Number(numString);
        let currentLang = this.translateService.currentLang;

        return num.toLocaleString(currentLang);
    }

    private drawArc(translates: any) {
        var min = Math.min(this.width, this.height);
        var arc = d3.arc().outerRadius((min / 2) - 10).innerRadius(0);


        if (this.mainChart.selectAll('.arcs'))
            this.mainChart.selectAll('.arcs').remove()

        this.chart = this.mainChart.append('g')
            .attr('transform', 'translate(' + translates.x + ',' + translates.y + ')').
            attr('class', 'arcs');

        //set arc properties
        var arcs = this.chart.selectAll('path');
        arcs = arcs.data(this.pie(this.donutDataForDisplay));
        arcs.exit().remove();
        arcs.enter().append('path')
            .attr('fill', (d, i) => this.getColor(i))
            .transition()
            .duration((d, i) => {
                return i * 200;
            })
            .attrTween('d', (d) => {
                var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
                return (t) => {
                    d.endAngle = i(t);
                    return arc(d);
                }
            });


        // update all the arcs (not just the ones that might have been added)
        arcs.attr('d', arc);

        arcs.enter().append("text")
            .attr("transform", (d) => { return "translate(" + arc.centroid(d) + ")"; })
            .attr("text-anchor", "middle")
            .attr("font-family", this.currentStyle.font)
            .attr('fill', this.currentStyle.font_color)
            .attr("font-size", this.currentStyle.font_size)
            .style("font-size", this.currentStyle.font_size)
            .text((d, index) => {
                if (d.data != 0) {
                    // if the arch angle is greater than 2 then only display text in arc
                    //else  text will get displayed outside arch as a label
                    if (Math.round(d.endAngle - d.startAngle) >= 1) {
                        if (d.data != undefined && d.data != null && !(Math.floor(d.data) == d.data)) {
                            d.data = d.data.toFixed(2);
                        }
                        let data = this.convertToLocaleNumber(d.data.toString());
                        return data;// d.data;
                    }
                    else {
                        return "";
                    }
                }
            }
            );
        this.addToolTip();
        this.enterLabels((min / 2) - 10, translates);

    }


    getTranslateYForPie(): any {
        let translateX = 0;
        let translateY = 0;

        //legend adjustment
        if (this.currentStyle.legend_position == "left" && this.currentStyle.legend_visible) {
            translateX = (this.width / 2) + this.legendWidthOffset
        }
        else if (this.currentStyle.legend_position == "right " && this.currentStyle.legend_visible) {
            translateX = (this.width / 2);
        }
        else
            translateX = this.width / 2;

        if (this.currentStyle.legend_position == "top" && this.currentStyle.legend_visible) {
            translateY = (this.height / 2) + this.legendHeightoffset

        }
        else if (this.currentStyle.legend_position == "bottom" && this.currentStyle.legend_visible) {
            translateY = (this.height / 2);
        }
        else
            translateY = this.height / 2;

        var translates = {
            "x": translateX,
            "y": translateY
        }
        return translates;
    }

    private legendHeightoffset = 0;

    private DrawLegends(titleHeight: number, haserror: boolean) {
        try {
            var legenddata: any = [];
            for (let i = 0; i < this.pieChartData.length; i++) {
                legenddata.push(
                    {
                        "key": this.pieChartData[i].key,
                        "value": this.pieChartData[i].value,
                        "color": this.invalidData ? "Black" : this.getColor(i)
                    });
            }

            var legendStyle = {
                "font-size": this.currentStyle.legend_font_size,
                "fill": this.currentStyle.legend_font_color,
                "font-family": this.currentStyle.legend_font
            }

            var widgetDimension = {
                "height": this.height,
                "width": this.width
            }

            let legendPosition = this.currentStyle.legend_position;

            if (this.mainChart.selectAll(".legendSectionMain"))
                this.mainChart.selectAll(".legendSectionMain").remove()


            let legend = this.mainChart.append('g')
                .attr("class", "legendSectionMain");

            var rowsinserted = this.widgetHelper.getDivisionForLegend(legendPosition, legendStyle, legenddata, legend, widgetDimension);

            // var dynamicLegend = legend.selectAll(".templegend");

            if (legendPosition === "left" || legendPosition === "right") {
                this.legendWidthOffset = d3.max(this.mainChart.selectAll(".templegend").nodes(), (d: any) => { return d.getBBox().width as number })

                let yfactor = 1
                let xfactor = legendPosition === "right" ? this.width - this.legendWidthOffset : 1;
                var translate = "translate(" + (xfactor) + "," + (yfactor) + ")"

                legend.attr("transform", translate);
                this.width = this.width - this.legendWidthOffset;
            }
            else if (legendPosition == "top") {
                //var yfactor = this.currentStyle.title_position == "top" || haserror ? titleHeight + 5 : 1;
                var yfactor = 1;
                this.legendHeightoffset = d3.max(this.mainChart.selectAll(".templegend").nodes(), (d: any) => { return d.getBBox().height as number });
                var translate = "translate(" + (1) + "," + (yfactor) + ")"
                legend.attr("transform", translate);

                this.height = this.height - this.legendHeightoffset;
            }
            else if (legendPosition === "bottom") {
                this.legendHeightoffset = d3.max(this.mainChart.selectAll(".templegend").nodes(), (d: any) => {
                    return d.getBBox().height as number
                });
                //+ 5 as adjustmentfactor
                var yfactor = this.currentStyle.title_position == "bottom" ?
                    (this.height - this.legendHeightoffset + 5) :
                    (this.height - this.legendHeightoffset + titleHeight + 5);

                if (haserror)
                    yfactor = yfactor - (titleHeight + 5);

                var translate = "translate(" + (1) + "," + (yfactor) + ")"
                legend.attr("transform", translate);

                this.height = this.height - this.legendHeightoffset;
            }
        }
        catch (error) {
            this.logger.logError("PieChart", "Error while drawing Pie chart. Error:" + error);
        }
    }

    applyStyles() {
        for (let propName in this.defaultStyle) {
            var propertyName = propName.replace(/-/g, "_");
            let propValue = this.widgetStyle[propName];
            if (propValue !== undefined) {
                this.currentStyle[propertyName] = propValue;
            }
            else {
                this.currentStyle[propertyName] = this.defaultStyle[propName];
            }
        }
        // this.colors = d3.scaleLinear().domain([0, this.donutDataForDisplayText.length]).range(
        //     <any[]>[this.currentStyle.start_color, this.currentStyle.end_color]);
        this.colors = this.currentStyle.colors;
        this.logger.logInfo("PieChart", " styles are: " + JSON.stringify(this.currentStyle));
    }

    Update(data: PieResponseObject) {
        try {
            let element = this.chartContainer.nativeElement;
            this.logger.logInfo("PieChart", "Update called received from provider");

            this.width = this.width = element.offsetWidth - (this.currentStyle.margin.right + this.currentStyle.margin.left);
            this.height = element.offsetHeight - (this.currentStyle.margin.bottom + this.currentStyle.margin.top);

            this.pieChartData = data.ResponseArrayCollection[0];
            if (this.pieChartData) {
                this.createvalueCollection(); // create values collection
            } else {
                this.invalidData = true;
            }
            if (element.offsetHeight != 0 && element.offsetWidth != 0) {
                //this.chartContainer.nativeElement.innerHTML = "";
                if (this.invalidData) {
                    this.displayError(element, this.ERROR_TEXT_INVALID_DATA_PIE, this.currentStyle.legend_visible);
                    return
                }

                this.chartContainer.nativeElement.innerHTML = "";
                this.drawPieChart(element);

                /* if (this.mainChart.selectAll(".templegend"))
                     this.mainChart.selectAll(".templegend").remove()
 
                 this.height = this.height - this.titleHeight;
                 var translates = this.getTranslateYForPie();
 
                 this.drawArc(translates);*/
            }
        }
        catch (error) {
            this.logger.logError("PieChart", "Error while drawing Pie chart. Error:" + error);
        }
    }

    private addToolTip() {
        var element = this.chartContainer.nativeElement;
        this.chartUniqueId = this.generateUUID();
        var tooltipDiv = d3.select(element).append("div").attr("class", "customToolTip").attr("id", this.chartUniqueId);
        var arcsforTooltip = this.chart.selectAll('path');

        arcsforTooltip.on("mousemove", (d) => {
            if (navigator.userAgent.indexOf("Chrome") != -1) {
                tooltipDiv.style("left", d3.event.offsetX + 10 + "px");
                tooltipDiv.style("top", d3.event.offsetY - 25 + "px");
            }
            else {
                tooltipDiv.style("left", d3.event.x + 10 + "px");
                tooltipDiv.style("top", d3.event.y - 25 + "px");
            }
            tooltipDiv.style("display", "inline-block");
            tooltipDiv.style("background", this.currentStyle.tooltip_background);
            tooltipDiv.style('color', this.currentStyle.tooltip_font_color)
            tooltipDiv.style("font-size", this.currentStyle.tooltip_font_size + "px");
            tooltipDiv.style("font-family", this.currentStyle.tooltip_font);
            tooltipDiv.html((this.donutDataForDisplayText[d.index]) + "<br>" + this.convertToLocaleNumber(d.value));
        });

        arcsforTooltip.on("mouseout", (d) => {
            tooltipDiv.style("display", "none");
        });
    }

    getConfig() {
        return this.dataProvider.privateConfig;
    }

    private enterLabels(outer_radius: number, translates: any) {
        let filteredData = this.donutDataForDisplay.filter(obj => obj !== 0);
        var textOffset = 5;

        if (this.mainChart.selectAll('.label_group'))
            this.mainChart.selectAll('.label_group').remove()

        var label_group = this.mainChart.append("g")
            .attr("class", "label_group")
            .attr("transform", "translate(" + translates.x + "," + translates.y + ")");

        let nameLabels = label_group.selectAll("text.units").data(this.pie(filteredData))

        nameLabels.enter().append("svg:text")
            .attr("class", "units")
            .attr("font-family", this.currentStyle.font)
            .attr('fill', this.currentStyle.font_color)
            .attr("font-size", this.currentStyle.font_size)
            .style("font-size", this.currentStyle.font_size)
            .attr("transform", function (d) {
                return "translate(" + Math.cos(((d.startAngle + d.endAngle - Math.PI) / 2)) *
                    (outer_radius + textOffset) + "," +
                    Math.sin((d.startAngle + d.endAngle - Math.PI) / 2) *
                    (outer_radius + textOffset) + ")";
            })
            .attr("dy", (d) => {
                if ((d.startAngle + d.endAngle) / 2 > Math.PI / 2 && (d.startAngle + d.endAngle) / 2 < Math.PI * 1.5)
                    return 5;
                else
                    return 3;
            })
            .attr("text-anchor", (d) => {
                if ((d.startAngle + d.endAngle) / 2 < Math.PI)
                    return "beginning";
                else
                    return "end";
            }).text((d) => {
                if (Math.round(d.endAngle - d.startAngle) >= 1)
                    return "";
                else {
                    //if the  negativeValueIndex collection contains current index
                    // then prefix value with minus (-) sign
                    if (d.data != undefined && d.data != null && !(Math.floor(d.data) == d.data)) {
                        d.data = d.data.toFixed(2);
                    }
                    return d.data;
                }
            });

        nameLabels.transition().duration((d, i) => {
            return i * 200;
        });

        nameLabels.exit().remove();

    }

    private generateUUID(): string {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

        return uuid;
    }

    private getColor(index: number): string {
        const multiple: number = Math.floor(index / 10) * 10;
        if (index > 9) {
          index = index - multiple;
        }
        return this.colors[index];
      }
}
